import { formatCurrency } from './formatter'

export const isEmptyString = str => {
  return !str || str.toString().trim().length === 0
}

export const pluralize = (
  count,
  unit,
  asCurrency = false,
  currencyDecimal = 2,
  fixedUnit = false,
) => {
  const countDisplay = asCurrency
    ? formatCurrency(count, currencyDecimal)
    : count.toString()

  if (!unit) return countDisplay
  if (fixedUnit) return `${countDisplay} ${unit}`
  return `${countDisplay} ${unit}${count > 1 ? 's' : ''}`
}
